import api from "./api";

export const getAllVlans = async (schemaName = null) => {
  try {
    const response = await api.get("/vlans/", {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching vlans:", error);
    throw error;
  }
};

export const getVlanbyId = async (id, schemaName = null) => {
  try {
    const response = await api.get(`/vlans/${id}`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching vlan:", error);
    throw error;
  }
};

export const createVlan = async (vlanData, schemaName = null) => {
    try {
      const response = await api.post("/vlans/", vlanData, {
        params: schemaName ? { client: schemaName } : {},
      });
      return response.data;
    } catch (error) {
      console.error("Error creating vlan:", error);
      throw error;
    }
  };


export const updateVlan = async (id,vlanData, schemaName = null) => {
    try {
      const response = await api.put(`/vlans/${id}/`, vlanData, {
        params: schemaName ? { client: schemaName } : {},
      });
      return response.data;
    } catch (error) {
      console.error("Error updating vlan:", error);
      throw error;
    }
  }; 


  export const deleteVlan = async (id, schemaName = null) => {
    try {
      // axios.delete signature is (url, config); the params config must be the
      // second argument. The schema is sent as ?client= so staff/SP deletes
      // resolve the tenant (the backend reads client from the query on DELETE).
      const response = await api.delete(`/vlans/${id}/`, {
        params: schemaName ? { client: schemaName } : {},
      });
      return response.data;
    } catch (error) {
      console.error("Error deleting vlan:", error);
      throw error;
    }
  };